import { render, staticRenderFns } from "./RegisterConfirmModal.vue?vue&type=template&id=4b401f07&"
import script from "./RegisterConfirmModal.vue?vue&type=script&lang=js&"
export * from "./RegisterConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports